import { render, staticRenderFns } from "./SystemParameters.vue?vue&type=template&id=2577a8aa&scoped=true&"
import script from "./SystemParameters.vue?vue&type=script&lang=ts&"
export * from "./SystemParameters.vue?vue&type=script&lang=ts&"
import style0 from "./SystemParameters.vue?vue&type=style&index=0&id=2577a8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577a8aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
